import { useQuery } from "react-query";
import {
  getSponsorBySlug,
  getClaimsPageSponsors,
} from "./sponsors-service";

export const useKioskoBySlug = (slug: string) => {
  return useQuery(
    ["kiosko-config", slug],
    () => getSponsorBySlug(slug),
    {
      enabled: !!slug,
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  );
};

export const useClaimsPageSponsors = () => {
  return useQuery(["claims-page-sponsors"], () => getClaimsPageSponsors(), {
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
};
